import type { NetSuiteGetInvoiceDashboardUrlResponse } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { purge } from '@vy/utils';
import { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

export function useGetNetSuiteDashboardUrl(
  vayuInvoiceId: string,
  options?: CustomUseQueryOptions<NetSuiteGetInvoiceDashboardUrlResponse>,
) {
  const queryDeps = purge([vayuInvoiceId]);

  return useQuery(
    queryKeys.netSuiteInvoiceDashboardUrl(...queryDeps),
    () => {
      const api = getPrivateApi();

      return api.netSuiteGetInvoiceDashboardUrl({ vayuInvoiceId });
    },
    {
      ...options,
    },
  );
}
